import { ReferanceAsyncSelect } from './referance-async-select'

export function SelectReferanceCodeLabel12({ name }) {
  return <ReferanceAsyncSelect name={name} labelCategory="LABEL12 KARTI" />
}
